export var STICKY_SEARCH_KEY = 'atlassian.search-dialog-sticky';
export var SEARCH_QUERY_KEY = 'atlassian.search-dialog-query';
export var SEARCH_FILTERS_KEY = 'atlassian.search-dialog-filters';
export var SEARCH_SHOW_AI_DIALOG_KEY = 'atlassian.search-dialog.ai-dialog';
export var getSessionItem = function getSessionItem(key) {
  return window.sessionStorage.getItem(key);
};
export var setSessionItem = function setSessionItem(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
  } catch (error) {
    if (error.code === DOMException.QUOTA_EXCEEDED_ERR) {
      // Do nothing if the sessionStorage capacity is reached
    } else {}
  }
};
export var deleteSessionItem = function deleteSessionItem(key) {
  window.sessionStorage.removeItem(key);
};